import React from "react";
import variables from "Assets/style/variablesExport.module.scss";
import CapacityBar from "./CapacityBar/CapacityBar";

type DownloadGaugeProps = {
  capacity: number;
  used: number;
};

const DownloadUsageBar = ({
  capacity,
  used,
}: DownloadGaugeProps): React.JSX.Element => {
  const usages = [
    {
      name: "Download",
      used: used,
      color: variables.portal_usage_fill_color,
    },
  ];

  return (
    <CapacityBar
      totalCapacity={capacity}
      usages={usages}
      unit="GB"
      showLegend={false}
    />
  );
};

export default DownloadUsageBar;
